import { Breadcrumbs } from '@src/shared/ui/components/Breadcrumbs';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * Section: Main
 *
 * This is where the main content of the page will be rendered.
 *
 * @param children
 * @returns {Element}
 * @constructor
 */
export function Main({ children }) {
  return (
    <ErrorHandler location="src/shared/ui/layouts/Application/sections/Main/Main.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <main id="app-main">
          <PageBody
            css={{
              paddingBottom: 'var(--abyss-space-md)',
              paddingTop: 'var(--abyss-space-md)',
            }}
            fullWidth
          >
            <section id="app-breadcrumbs">
              <Breadcrumbs />
            </section>
            <motion.div
              animate="open"
              initial={{ opacity: 0 }}
              variants={{
                closed: { opacity: 0 },
                open: { opacity: 1 },
              }}
            >
              {children}
            </motion.div>
          </PageBody>
        </main>
      </motion.div>
    </ErrorHandler>
  );
}
